import { cn } from "@/lib/utils";

interface LogoIconProps {
  className?: string;
  size?: number;
}

/**
 * AI 内容创作平台 logo — 一支书写中的笔 + AI 星芒。
 * 笔承载内容创作的起点（文/图/视频/音频都从它开始），星芒是 AI 生成的火花。
 * 旧版是漫画气泡 + 分镜线（贴合旧名「AI 漫剧生成器」）——
 * 品牌改为全内容类型平台后图标同步重绘（2026-10-08）。
 *
 * 🔴 渲染尺寸只有 14px（header / 项目栏）、favicon 32px ——
 * 全部**实心填充**、不画细描边：14px 下任何 <2 单位的线条都会糊成一团。
 * 笔身用 `rotate(45)` 组变换而不是手算斜四边形顶点（手算极易出错一点就歪）。
 */
export function LogoIcon({ className, size = 20 }: LogoIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* AI 星芒（左上）：四角星，AI 生成内容的火花 */}
      <path
        d="M8 2.5 L9.9 6.1 L13.5 8 L9.9 9.9 L8 13.5 L6.1 9.9 L2.5 8 L6.1 6.1 Z"
        fill="currentColor"
        fillOpacity="0.9"
      />
      {/* 书写笔（右下主形）：竖直画好再整体旋转 45°，笔尖指向左下 */}
      <g transform="rotate(45 16 16)">
        {/* 笔身 */}
        <rect x="12.8" y="6" width="6.4" height="15" rx="1" fill="currentColor" />
        {/* 笔帽（橡皮端，略淡以分层） */}
        <rect
          x="12.8"
          y="3"
          width="6.4"
          height="4"
          rx="1.4"
          fill="currentColor"
          fillOpacity="0.75"
        />
        {/* 笔尖 */}
        <path d="M12.8 21 L16 27 L19.2 21 Z" fill="currentColor" />
      </g>
    </svg>
  );
}

export function LogoFull({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <div className="flex h-8 w-8 items-center justify-center rounded-[10px] bg-[var(--primary)] text-white">
        <LogoIcon size={18} />
      </div>
      <span className="font-display text-[15px] font-bold tracking-tight text-[#1A1A1A]">
        AI 内容创作平台
      </span>
    </div>
  );
}
